/* istanbul ignore file */
import React from 'react';
import { DropDownFilter } from 'framework/list';
import VacancyStatusDropdown from 'domain/recruiting/vacancy/shared/input/VacancyStatusDropdown';

const VacancyStatusFilter = (props: any) => {
  return (
    <DropDownFilter {...props}>
      <VacancyStatusDropdown />
    </DropDownFilter>
  );
};

export default VacancyStatusFilter;
